import React from 'react';
import { LoaderLogo } from 'assets';
import ComponentLoader from './ComponentLoader';
import styles from './LoaderStyle.module.css';

const Loader = () => {
  return (
    <div className={`${styles['lod-overlay']}`}>
      <div className={`${styles['load-container']}`}>
        <div className={`${styles['loader']}`}></div>
        <img src={LoaderLogo} className={`${styles['lod-img']}`} alt="" />
      </div>
    </div>
  );
};

export default Loader;
export { Loader, ComponentLoader };
